import React, { useState } from "react";
import { Card, Typography, Badge } from "antd";
import { primeColor, primeColorLight } from "../../theme";
import ReactHtmlParser from "react-html-parser";

const featureList = text => (
    <Badge
        color={primeColor}
        text={<span style={{ fontSize: "0.875rem" }}>{text}</span>}
        style={{ marginBottom: "0.125rem", display: "block" }}
    />
);

const { Text, Title } = Typography;

const PlanCard = props => {
    const {
        highlighted,
        title,
        subTitle,
        descriptions,
        footer,
        handleClick,
        custom,
        children,
    } = props;

    const [hover, setHover] = useState(false);
    return (
        <Card
            bordered={true}
            hoverable={true}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                borderWidth: "1px",
                height: "100%",
                borderColor: primeColor,
                position: "relative",
                ...(highlighted && { borderColor: primeColor }),
                ...(highlighted && { boxShadow: `inset 0 0 0 2px ${primeColor}` }),
                ...(highlighted && { backgroundColor: primeColorLight }),
                ...(hover && { backgroundColor: primeColorLight }),
            }}
            onClick={handleClick}
        >
            <Title type="secondary" level={3}>
                {title}
            </Title>
            {subTitle && (
                <Text
                    style={{
                        fontSize: "0.85rem",
                        whiteSpace: !custom && "nowrap",
                    }}
                >
                    {ReactHtmlParser(subTitle)}
                </Text>
            )}
            {children}
            <div style={{ marginTop: "1rem" }}>
                {descriptions &&
                    descriptions.length > 0 &&
                    descriptions.map((description, index) => (
                        <span key={index}>{featureList(ReactHtmlParser(description))}</span>
                    ))}
            </div>
            <div style={{ height: "100%" }}></div>
            <footer
                style={{
                    position: "absolute",
                    color: "grey",
                    fontSize: "0.75rem",
                    bottom: "1rem",
                }}
            >
                {ReactHtmlParser(footer)}
            </footer>
        </Card>
    );
};

export default PlanCard;
